define('controller/disclosure/disclosure.assigned.to.me.list.controller',['require','exports','module','fukit','view/disclosure/disclosure.assignedToMe.list.page.vew','model/disclosure.model','model/disclosure.unsubmitted.report.model','model/disclosure.detail.model','fukit'],function(require, exports, module){
  var BaseController         = require('fukit').BaseController;
  var DisclosureAssignedToMeListPageView = require('view/disclosure/disclosure.assignedToMe.list.page.vew');
  var DisclosureModel        = require('model/disclosure.model');
  var DisclosureUnsubmittedReportModel   = require('model/disclosure.unsubmitted.report.model');
  var DisclosureDetailModel  = require('model/disclosure.detail.model');
  var ROLES                  = require('fukit').Roles;

  var DisclosureAssignedToMeListController = BaseController.extend({
    radioRequests: {
      'controllers DisclosureAssignedToMeListController': '@constructor'
    },

    pageView: DisclosureAssignedToMeListPageView,

    stateConfiguration: {
      defaults: {
        roles: ROLES.GLOBALACCESSROLES
      }
    },

    resources: {
      newDisclosureModel: {
        model: DisclosureModel
      },
      disclosureCollection: {
        fetchOnStart: true,
        collection: DisclosureDetailModel.Collection,
        sort: {
          field: 'createDate',
          direction: 'descending'
        },
        filters: [{
          field: 'disclosureReviewerUserId',
          value: '@state.disclosureReviewerUserId'
        },
          {
            field: 'status',
            value: 'Under Review',
          },]
      },
      disclosureUnsubmittedReportModel: {
        model: DisclosureUnsubmittedReportModel,
      },
    }

  });

  module.exports = DisclosureAssignedToMeListController;
});

